import axios from "axios";

export async function fetchSpinInfo(spinURL) {
  const infoUrl = `${spinURL}?info`;
  const response = await axios.get(infoUrl);
  const json = response.data;
  return json;
}
